import { render } from "./ElectionCampaignChronic.vue?vue&type=template&id=960d2c4e&scoped=true"
import script from "./ElectionCampaignChronic.vue?vue&type=script&lang=js"
export * from "./ElectionCampaignChronic.vue?vue&type=script&lang=js"

import "./ElectionCampaignChronic.vue?vue&type=style&index=0&id=960d2c4e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-960d2c4e"]])

export default __exports__